/**
 * Returns array of strings to build page group based on url
 * @param {String[]} pathList
 * @returns {String[]}
 */
export function getPgrp(pathList) {
  let pgrp = ['main', 'developer']

  for (let i = 0; i < pathList.length; i++) {
    if (pathList[i]) pgrp.push(pathList[i])
    else break
  }
  if (pgrp[2] === 'developer') pgrp[2] = 'dashboard'
  if (pgrp.includes('applications') && pgrp.includes('edit')) {
    const clientIdIndex = pgrp.indexOf('edit') + 1
    if (pgrp[clientIdIndex] && !pgrp[clientIdIndex].startsWith('SB:')) {
      pgrp[clientIdIndex] = 'live:' + pgrp[clientIdIndex]
    }
  }
  return pgrp
}
